(function () {
  var _updating = false;
  var _locale = (typeof Shopify !== 'undefined' && Shopify.locale)
    ? Shopify.locale.split('-')[0].toLowerCase()
    : (document.documentElement.lang || 'en').split('-')[0].toLowerCase();

  var _t = {
    de: {
      hotelPickup: 'Möchten Sie einen Hotelabholservice?',
      hotelAddress: 'Hoteladresse',
      meetingPoint: 'Treffpunkt',
      no: 'Nein',
      yes: 'Ja'
    },
    es: {
      hotelPickup: '¿Desea servicio de recogida en el hotel?',
      hotelAddress: 'Dirección del hotel',
      meetingPoint: 'Punto de encuentro',
      no: 'No',
      yes: 'Sí'
    }
  };

  var _addSlotLabel = {
    en: 'Number of travelers',
    de: 'Anzahl der Reisenden',
    es: 'Número de viajeros'
  };

  var _submitHintLabel = {
    en: 'Please enter your hotel address above to enable booking',
    de: 'Bitte geben Sie oben Ihre Hoteladresse ein, um die Buchung zu aktivieren',
    es: 'Introduzca la dirección de su hotel arriba para poder reservar'
  };

  var _privateTourGroupLabel = 'Group size';

  function isPrivateTour() {
    var el = document.getElementById('tipo-product-type');
    return !!el && el.getAttribute('data-value') === 'Private Tour';
  }

  var _removeLabel = {
    en: 'Remove',
    de: 'Entfernen',
    es: 'Eliminar'
  };

  function getRadioValue() {
    var checked = document.querySelector('input[name="radiobutton-1"]:checked');
    return checked ? checked.value : null;
  }

  function getAddress() {
    var addr = document.querySelector('input[name="singleLineText-1"]');
    return addr ? addr.value.trim() : '';
  }

  function getPersons() {
    var select = document.querySelector('select[name="bring_qty"]');
    if (select) {
      var n = parseInt(select.value, 10);
      if (!isNaN(n)) return n + 1;
    }
    return 1;
  }

  function getAddonCents() {
    var content = document.querySelector('.tpb__form-module__content:has(input[value="Yes"][name="radiobutton-1"])');
    if (!content) return 0;
    var span = content.querySelector('span[data-add-on-price]');
    if (!span) return 0;
    return parseInt(span.getAttribute('data-add-on-price'), 10) || 0;
  }

  function getMeetingPoint() {
    var el = document.getElementById('tipo-meeting-point');
    return el ? el.getAttribute('data-value') : '';
  }

  function applyTranslations() {
    if (_updating || _locale === 'en' || !_t[_locale]) return;
    var t = _t[_locale];
    _updating = true;

    document.querySelectorAll('[data-form-label]').forEach(function (el) {
      var lbl = el.getAttribute('data-form-label');
      var replacement = null;
      if (lbl === 'Do you want hotel pick up ?' && t.hotelPickup) replacement = t.hotelPickup + ' ';
      if (lbl === 'Hotel address' && t.hotelAddress) replacement = t.hotelAddress + ' ';
      if (!replacement) return;
      for (var i = 0; i < el.childNodes.length; i++) {
        if (el.childNodes[i].nodeType === 3 && el.childNodes[i].textContent.trim()) {
          if (el.childNodes[i].textContent.trim() !== replacement.trim()) {
            el.childNodes[i].textContent = replacement;
          }
          break;
        }
      }
    });

    ['No', 'Yes'].forEach(function (val) {
      var tVal = t[val.toLowerCase()];
      if (!tVal) return;
      document.querySelectorAll('input[value="' + val + '"][name="radiobutton-1"]').forEach(function (input) {
        var content = input.closest('.tpb__form-module__content');
        if (!content) return;
        for (var i = content.childNodes.length - 1; i >= 0; i--) {
          if (content.childNodes[i].nodeType === 3 && content.childNodes[i].textContent.trim()) {
            if (content.childNodes[i].textContent.trim() !== tVal) {
              content.childNodes[i].textContent = ' ' + tVal;
            }
            break;
          }
        }
      });
    });

    _updating = false;
  }

  function updateHotelPickupVisibility() {
    if (_updating) return;
    var noInput = document.querySelector('input[value="No"][name="radiobutton-1"]');
    var yesInput = document.querySelector('input[value="Yes"][name="radiobutton-1"]');
    if (!noInput || !yesInput) return;
    if (!noInput.checked && !yesInput.checked) return;

    var radioGroup = noInput.closest('.tpb__form-module__formGroup');
    if (!radioGroup) return;
    var nextGroup = radioGroup.nextElementSibling;
    while (nextGroup && !nextGroup.classList.contains('tpb__form-module__formGroup')) {
      nextGroup = nextGroup.nextElementSibling;
    }

    _updating = true;

    if (nextGroup) {
      nextGroup.style.setProperty('display', yesInput.checked ? 'block' : 'none', 'important');
    }

    var mpText = getMeetingPoint();
    var mpLabel = (_t[_locale] ? _t[_locale].meetingPoint : null) || 'Meeting point';

    var addr = document.querySelector('input[name="singleLineText-1"]');
    if (addr) {
      if (noInput.checked && mpText) {
        if (addr.value !== mpText) addr.value = mpText;
      } else if (yesInput.checked && addr.value === mpText) {
        addr.value = '';
      }
      var addrGroup = addr.closest('.tpb__form-module__formGroup');
      var addrLabel = addrGroup && addrGroup.querySelector('[data-form-label]');
      if (addrLabel) {
        var targetLabel = noInput.checked ? mpLabel : 'Hotel address';
        for (var i = 0; i < addrLabel.childNodes.length; i++) {
          if (addrLabel.childNodes[i].nodeType === 3 && addrLabel.childNodes[i].textContent.trim()) {
            addrLabel.childNodes[i].textContent = targetLabel + ' ';
            break;
          }
        }
        addrLabel.setAttribute('data-form-label', targetLabel);
      }
    }

    var noteId = 'tipo-mp-note';
    var existing = document.getElementById(noteId);

    if (noInput.checked && mpText) {
      var newHtml = '<p style="margin:0 0 4px;font-size:12px;color:#555;">' + mpLabel + '</p>'
        + '<p style="margin:0;font-size:14px;font-weight:600;color:#111;">' + mpText + '</p>';
      if (!existing) {
        existing = document.createElement('div');
        existing.id = noteId;
        existing.style.cssText = 'margin:8px 0;text-align:left;width:100%;';
        radioGroup.parentElement.insertBefore(existing, nextGroup || null);
      }
      if (existing.innerHTML !== newHtml) existing.innerHTML = newHtml;
      if (existing.style.display === 'none') existing.style.display = '';
    } else if (existing && existing.style.display !== 'none') {
      existing.style.display = 'none';
    }

    _updating = false;
  }

  function updateAddonLine() {
    if (_updating) return;
    var row = document.querySelector('.tpb__summary-module__total .tpb__summary-module__row');
    if (!row) return;
    var existing = document.querySelector('.tipo-addon-line');
    var isYes = getRadioValue() === 'Yes';

    _updating = true;

    if (!isYes) {
      if (existing) existing.remove();
      _updating = false;
      return;
    }

    var addonEur = getAddonCents() / 100;
    var persons = getPersons();
    var total = addonEur * persons;
    var html = '<div>Hotel pick-up</div><div class="tpb__summary-module__value">+ €' + total.toFixed(2).replace('.', ',') + '</div>';

    if (existing) {
      if (existing.innerHTML !== html) existing.innerHTML = html;
    } else {
      existing = document.createElement('div');
      existing.className = 'tpb__summary-module__row tipo-addon-line';
      existing.style.cssText = 'color:#B80B1F;font-weight:600;margin-top:4px;';
      existing.innerHTML = html;
      row.parentElement.appendChild(existing);
    }

    _updating = false;
  }

  function updateSubmitBtn() {
    var btn = document.querySelector('button[data-button-submit]');
    if (!btn) return;
    var disabled = false;

    var val = getRadioValue();
    var addrVal = getAddress();
    var mpVal = getMeetingPoint();
    if (val === 'Yes' && (!addrVal || addrVal === mpVal)) disabled = true;

    if (!disabled) {
      var nowChecked = document.querySelector('input[value="Hotel address"]:checked');
      if (nowChecked) {
        var radioGroup = nowChecked.closest('.tpb__form-module__formGroup');
        var nextGroup = radioGroup && radioGroup.nextElementSibling;
        while (nextGroup && !nextGroup.classList.contains('tpb__form-module__formGroup')) {
          nextGroup = nextGroup.nextElementSibling;
        }
        if (nextGroup) {
          var input = nextGroup.querySelector('input[type="text"], textarea');
          if (input && !input.value.trim()) disabled = true;
        }
      }
    }

    btn.disabled = disabled;
    btn.style.opacity = disabled ? '0.5' : '';
    btn.style.cursor = disabled ? 'not-allowed' : '';

    updateSubmitHint(btn, disabled);
  }

  function updateSubmitHint(btn, disabled) {
    var hintId = 'tipo-submit-hint';
    var existing = document.getElementById(hintId);
    if (disabled && getRadioValue() === 'Yes') {
      if (!existing) {
        existing = document.createElement('div');
        existing.id = hintId;
        existing.style.cssText = 'margin-top:8px;font-size:13px;font-weight:600;color:#B80B1F;text-align:center;width:100%;';
        existing.textContent = _submitHintLabel[_locale] || _submitHintLabel.en;
        btn.insertAdjacentElement('afterend', existing);
      }
    } else if (existing) {
      existing.remove();
    }
  }

  function fixRadioClickTarget() {
    document.querySelectorAll('.tpb__form-module__field.tpb__form-module__radio').forEach(function (field) {
      if (field._tipoClickBound) return;
      field._tipoClickBound = true;
      field.addEventListener('click', function (e) {
        var input = field.querySelector('input[type="radio"]');
        if (!input || e.target === input || input.checked) return;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function fixTravelerDropdown() {
    var container = document.querySelector('[data-block-add-slot-dropdown]');
    if (!container) return;
    container.querySelectorAll('[data-tpb-dropdown-option][data-value]').forEach(function (item) {
      if (item.getAttribute('data-tipo-fixed')) return;
      var val = parseInt(item.getAttribute('data-value'), 10);
      if (isNaN(val)) return;
      var label = item.querySelector('.tpb__dropdown-module__menu_item_value');
      if (label) {
        label.textContent = String(val + 1);
        item.setAttribute('data-tipo-fixed', '1');
      }
    });
  }

  function fixTravelerActivator() {
    var select = document.querySelector('select[name="bring_qty"]');
    if (!select) return;
    var container = select.closest('[data-block-add-slot-dropdown]');
    if (!container) return;
    var activatorLabel = container.querySelector('[data-tpb-dropdown-activator-label]');
    if (!activatorLabel) return;
    var val = parseInt(select.value, 10);
    if (isNaN(val)) return;
    var expected = String(val + 1);
    if (activatorLabel.textContent.trim() !== expected) {
      activatorLabel.textContent = expected;
    }
  }

  function fixRemoveBtn() {
    var btn = document.querySelector('button[data-toggle-guest]');
    if (!btn || btn._tipoRemoveFixed) return;
    var text = _removeLabel[_locale] || _removeLabel.en;
    if (btn.textContent.trim() !== text) btn.textContent = text;
    btn._tipoRemoveFixed = true;
  }

  function fixAddSlotLabel() {
    var label = document.querySelector('.tpb__widget-module__addSlot .tpb__widget-module__label');
    if (!label) return;
    var text = isPrivateTour() ? _privateTourGroupLabel : (_addSlotLabel[_locale] || _addSlotLabel.en);
    for (var i = 0; i < label.childNodes.length; i++) {
      if (label.childNodes[i].nodeType === 3) {
        if (label.childNodes[i].textContent.trim() !== text) {
          label.childNodes[i].textContent = text;
        }
        return;
      }
    }
    label.insertBefore(document.createTextNode(text), label.firstChild);
  }

  function updateSpinner() {}

  function injectCompareAtPrice() {
    var span = document.getElementById('tipo-compare-at-price');
    if (!span || span.getAttribute('data-has') !== 'true') return;
    var compareAtCents = parseInt(span.getAttribute('data-value'), 10);
    if (!compareAtCents) return;
    var totalRow = document.querySelector('.tpb__summary-module__total .tpb__summary-module__row');
    if (!totalRow) return;
    var valueEl = totalRow.querySelector('.tpb__summary-module__value');
    if (!valueEl) return;
    var persons = getPersons() || 1;
    var total = (compareAtCents * persons / 100).toFixed(2).replace('.', ',');
    var formatted = '€' + total;
    var existing = totalRow.querySelector('.tipo-compare-at');
    if (existing) {
      if (existing.textContent !== formatted) existing.textContent = formatted;
    } else {
      var strike = document.createElement('span');
      strike.className = 'tipo-compare-at';
      strike.style.cssText = 'text-decoration:line-through;opacity:0.5;margin-right:6px;font-weight:400;';
      strike.textContent = formatted;
      valueEl.insertBefore(strike, valueEl.firstChild);
    }
  }

  function fixSummary() {
    if (_updating) return;
    document.querySelectorAll('.tpb__summary-module__devider').forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });
    document.querySelectorAll('.tpb__summary-module__service').forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });
    document.querySelectorAll('.tpb__summary-module__total').forEach(function (el) {
      el.style.setProperty('display', 'flex', 'important');
    });
  }

  function updateAddressVisibility() {
    document.querySelectorAll('input[value="Hotel address"], input[value="Provide address later"]').forEach(function (r) {
      if (!r._tipoNowLaterBound) {
        r._tipoNowLaterBound = true;
        r.addEventListener('change', updateAddressVisibility);
      }
    });
    var nowChecked = document.querySelector('input[value="Hotel address"]:checked');
    var laterChecked = document.querySelector('input[value="Provide address later"]:checked');
    if (!nowChecked && !laterChecked) return;
    var radioGroup = (nowChecked || laterChecked).closest('.tpb__form-module__formGroup');
    if (!radioGroup) return;
    var nextGroup = radioGroup.nextElementSibling;
    while (nextGroup && !nextGroup.classList.contains('tpb__form-module__formGroup')) {
      nextGroup = nextGroup.nextElementSibling;
    }
    if (!nextGroup) return;
    nextGroup.style.setProperty('display', nowChecked ? 'block' : 'none', 'important');
  }

  function attachListeners() {
    document.querySelectorAll('input[name="radiobutton-1"]').forEach(function (r) {
      if (r._tipoAddonBound) return;
      r._tipoAddonBound = true;
      r.addEventListener('change', function () {
        updateHotelPickupVisibility();
        updateSubmitBtn();
        updateAddonLine();
      });
    });
    var addr = document.querySelector('input[name="singleLineText-1"]');
    if (addr && !addr._tipoAddrBound) {
      addr._tipoAddrBound = true;
      addr.addEventListener('input', updateSubmitBtn);
    }
    var qty = document.querySelector('select[name="bring_qty"]');
    if (qty && !qty._tipoQtyBound) {
      qty._tipoQtyBound = true;
      qty.addEventListener('change', updateAddonLine);
    }
    var qtyActivator = document.querySelector('select[name="bring_qty"]');
    if (qtyActivator && !qtyActivator._tipoActivatorBound) {
      qtyActivator._tipoActivatorBound = true;
      qtyActivator.addEventListener('change', fixTravelerActivator);
    }
    updateAddressVisibility();

    document.querySelectorAll('input[value="Hotel address"], input[value="Provide address later"]').forEach(function (r) {
      if (!r._tipoNowSubmitBound) {
        r._tipoNowSubmitBound = true;
        r.addEventListener('change', updateSubmitBtn);
      }
    });

    var nowChecked = document.querySelector('input[value="Hotel address"]:checked');
    if (nowChecked) {
      var rg = nowChecked.closest('.tpb__form-module__formGroup');
      var ng = rg && rg.nextElementSibling;
      while (ng && !ng.classList.contains('tpb__form-module__formGroup')) ng = ng.nextElementSibling;
      if (ng) {
        var inp = ng.querySelector('input[type="text"], textarea');
        if (inp && !inp._tipoNowAddrBound) {
          inp._tipoNowAddrBound = true;
          inp.addEventListener('input', updateSubmitBtn);
        }
      }
    }
  }

  (function () {
    var page = document.querySelector('.tpb-product-page');
    if (!page) return;
    var spinner = document.createElement('div');
    spinner.id = 'tipo-ext-spinner';
    page.insertBefore(spinner, page.firstChild);
    var minUntil = Date.now() + 1000;
    function tryHide() {
      var content = document.querySelector('.tpb-widget-content');
      if (content && content.children.length > 0 && Date.now() >= minUntil) {
        spinner.style.display = 'none';
        return;
      }
      setTimeout(tryHide, 100);
    }
    tryHide();
  })();

  var observer = new MutationObserver(function () {
    if (_updating) return;
    updateSpinner();
    attachListeners();
    updateSubmitBtn();
    fixSummary();
    updateAddonLine();
    applyTranslations();
    fixAddSlotLabel();
    fixTravelerDropdown();
    fixTravelerActivator();
    fixRemoveBtn();
    injectCompareAtPrice();
    fixRadioClickTarget();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  updateSpinner();
  attachListeners();
  updateSubmitBtn();
  fixSummary();
  updateAddonLine();
  applyTranslations();
  fixAddSlotLabel();
  fixTravelerDropdown();
  fixTravelerActivator();
  fixRemoveBtn();
  updateHotelPickupVisibility();
  injectCompareAtPrice();
  fixRadioClickTarget();

  if (window.innerWidth <= 640) {
    var styleOverride = document.createElement('style');
    styleOverride.textContent = '.tpb__widget-module__wrapper { margin-bottom: 0 !important; } .tpb__widget-module__footer { background: transparent !important; border-radius: 0 !important; border: none !important; }';
    document.head.appendChild(styleOverride);
  }
})();
